import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Table, message, Tag, Button, Modal } from 'antd';
import { useSelector } from 'react-redux';

const { Column } = Table;
const { confirm } = Modal;

const MailReservateListPage = (props) => {
  const { user } = props;
  const [mailReservates, setMailReservates] = useState([]);
  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      if (usr.userData.isAuth) {
        const res = await Axios.get('/api/sendMail/reservate');
        if (res.data.success) {
          setMailReservates(res.data.mailReservates);
        } else {
          throw new Error('メール送信予約取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
  }, [usr]);

  // メール送信状態を表示する関数
  const getStatusTag = (status) => {
    switch (status) {
      case 0:
        return <Tag color="orange">予約中</Tag>;
      case 1:
        return <Tag color="blue">処理中</Tag>;
      case 5:
        return <Tag color="green">送信完了</Tag>;
      case 999:
        return <Tag color="red">送信エラー</Tag>;
      default:
        return <Tag color="default">不明</Tag>;
    }
  };

  // 日時フォーマット関数
  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
    );
  };

  // 実施区分を表示する関数
  const getAnswerStatus = (isAnswerd) => {
    switch (isAnswerd) {
      case '9':
        return '全体';
      case '0':
        return '未回答';
      case '5':
        return '回答済み';
      case 'CSV':
        return 'CSV';
      default:
        return '不明';
    }
  };

  // 予約削除処理
  const deleteReservate = async (id) => {
    try {
      const res = await Axios.delete(`/api/sendMail/reservate/${id}`);
      if (res.data.success) {
        message.success('予約が削除されました');
        readDB(); // リストを再読み込み
      } else {
        message.error('予約削除に失敗しました');
      }
    } catch (error) {
      console.log(error);
      message.error('予約削除で問題が発生しました');
    }
  };

  // 削除確認ダイアログ
  const showDeleteConfirm = (id) => {
    confirm({
      title: 'メール配信予約を削除しますか？',
      content: 'この操作は取り消すことができません。',
      okText: 'はい',
      okType: 'danger',
      cancelText: 'いいえ',
      onOk() {
        deleteReservate(id);
      },
    });
  };

  return (
    <div style={{ width: '90%', margin: '0rem auto' }}>
      <h2>メール送信予約一覧</h2>
      <Table dataSource={mailReservates} size="middle" rowKey="_id">
        <Column
          title="送信予定日時"
          dataIndex="send_date_time"
          key="send_date_time"
          render={(text) => formatDateTime(text)}
          aligh="left"
        />
        <Column
          title="企業名"
          dataIndex="group_name"
          key="group_name"
          aligh="left"
          render={(text) => text || '-'}
        />
        <Column
          title="サーベイシーズン名"
          dataIndex="season_name"
          key="season_name"
          aligh="left"
          render={(text) => text || '-'}
        />
        <Column
          title="設問セット名"
          dataIndex="set_name"
          key="set_name"
          aligh="left"
          render={(text) => text || '-'}
        />
        <Column
          title="テンプレート名"
          dataIndex="mt_name"
          key="mt_name"
          aligh="left"
        />
        <Column
          title="実施区分"
          dataIndex="isAnswerd"
          key="isAnswerd"
          render={(text) => getAnswerStatus(text)}
          aligh="center"
        />
        <Column
          title="メール配信状態"
          dataIndex="mail_send_status"
          key="mail_send_status"
          render={(text) => getStatusTag(text)}
          aligh="center"
        />
        <Column
          title="操作"
          key="action"
          render={(text, record) => (
            <Button
              type="danger"
              size="small"
              onClick={() => showDeleteConfirm(record._id)}
              disabled={record.mail_send_status !== 0} // 予約中(0)の場合のみ削除可能（処理中(1)は削除不可）
              style={{
                backgroundColor:
                  record.mail_send_status === 0 ? '#ff4d4f' : '#d9d9d9',
                borderColor:
                  record.mail_send_status === 0 ? '#ff4d4f' : '#d9d9d9',
                color: record.mail_send_status === 0 ? '#ffffff' : '#bfbfbf',
              }}
            >
              予約削除
            </Button>
          )}
        />
      </Table>
    </div>
  );
};

export default MailReservateListPage;
